import { Action } from 'redux';
import { DataAction } from '../@types';

export const UnauthorizedErrorActionType = 'unauthorizedError';

export type UnauthorizedErrorAction = DataAction<typeof UnauthorizedErrorActionType, Action>;

export function unauthorizedError(origin: Action): UnauthorizedErrorAction {
	return {
		data: origin,
		type: UnauthorizedErrorActionType
	};
}
